import { exportArrayToCsv } from '@/lib/csvExport';
import { stageLabel } from './JoBits';

const COLS = [
  ['jo_id', 'Job order'], ['fg_name', 'FG Name'], ['design_name', 'Design'], ['parent_fg_name', 'Parent Sort No FG Name'],
  ['shade', 'Shade'], ['send_to', 'Send to'],
  [(r) => (r.status === 'OPEN' ? stageLabel(r.stage) : stageLabel(r.status)), 'Status'], ['target_date', 'Expected delivery'],
  [(r) => (r.days_late > 0 ? r.days_late : ''), 'Days overdue'], ['ordered_pcs', 'Ordered'], ['on_slips_pcs', 'On pick slips'],
  ['transferred_pcs', 'Transferred'], ['received_pcs', 'Received back'], ['balance_to_send', 'Balance to send'],
  ['sort_no', 'Sort No'], ['vendor_name', 'Vendor'], ['nq', 'NQ'], ['need_assortment', 'Need Assortment'],
  ['free_bundles', 'Free bundles'], ['free_pcs', 'Free pcs'], ['colours', 'Colours (free pcs)'],
  ['parent_sort_no', 'Parent Sort No'], ['parent_free_bundles', 'Parent free bundles'], ['parent_free_pcs', 'Parent free pcs'],
  ['parent_colours', 'Parent colours (free pcs)'], ['total_free_pcs', 'Total free pcs (own + parent)'], ['note', 'Note'],
  ['created_by_name', 'Created by'], [(r) => (r.created_at || '').slice(0, 10), 'Created on'],
].map(([key, header]) => ({ key, header }));

/** Job orders × sort-no-wise stock (one row per sort no in stock) → CSV download. */
export const exportJoStockCsv = (rows) => exportArrayToCsv(rows, COLS, `processing-job-orders-stock-${new Date().toISOString().slice(0, 10)}.csv`);
